import Sticker from '@@types/Sticker';

import { STICKER_PAGE_COUNT } from '~/constants';

export interface TabState {
  readonly emoticonTabs: string[];
  readonly stickers: Sticker[];

  readonly tab: string;
  setTab(tab: string): void;

  readonly activeIndex: number;
  setActiveIndex(index: number): void;

  readonly page: number;
  setPage(page: number): void;
}

export abstract class EmoticonStickerTab {
  constructor(protected state: TabState) {}

  public isFocused = () => {
    return this.state.activeIndex === -1;
  };

  public left = () => {
    this.move(-1);
  };

  public canMoveLeft = () => {
    return this.canMoveIndex(this.getNewIndex(-1));
  };

  public right = () => {
    this.move(1);
  };

  public canMoveRight = () => {
    return this.canMoveIndex(this.getNewIndex(1));
  };

  public down = () => {
    this.tab();
  };

  public enter = () => {
    this.tab();
  };

  public tab = () => {
    if (this.state.activeIndex === -1) {
      this.state.setActiveIndex(0);
      return;
    }
  };

  protected canMoveIndex = (index: number) => {
    return index > -1 && index < this.getSize();
  };

  protected abstract move(delta: number): void;
  protected abstract getSize(): number;
  protected abstract getNewIndex(delta: number): number;
}

export class EmoticonTab extends EmoticonStickerTab {
  protected getSize = () => {
    return this.state.emoticonTabs.length;
  };

  protected getNewIndex = (delta: number) => {
    return this.state.emoticonTabs.indexOf(this.state.tab) + delta;
  };

  protected move = (delta: number) => {
    const newIndex = this.getNewIndex(delta);
    if (!this.canMoveIndex(newIndex)) {
      return;
    }
    const newTab = this.state.emoticonTabs[newIndex];
    this.state.setTab(newTab);
  };
}

export class StickerTab extends EmoticonStickerTab {
  private canMovePage = (page: number) => {
    return page > -1 && page < this.state.stickers.length;
  };

  protected getSize = () => {
    return this.state.stickers.length;
  };

  protected getNewIndex = (delta: number) => {
    return this.state.stickers.findIndex((tab) => tab.id === this.state.tab) + delta;
  };

  protected move = (delta: number) => {
    const newIndex = this.getNewIndex(delta);
    if (!this.canMoveIndex(newIndex)) {
      return;
    }
    this.state.setTab(this.state.stickers[newIndex].id);
    const newPage = Math.floor(newIndex / STICKER_PAGE_COUNT);
    this.canMovePage(newPage) && this.state.page !== newPage && this.state.setPage(newPage);
  };
}
